import { getAuth } from "firebase/auth";
import FriendRequest from "../models/FriendRequest.js";
import axios from "axios";

const GET_REQUESTS_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net/get_friend_requests";
const GET_FRIENDS_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net/get_friends";
const SEND_FRIEND_REQUEST = "https://europe-west3-hyper-e122e.cloudfunctions.net/send_friend_request";
const HANDLE_FRIEND_REQUEST = "https://europe-west3-hyper-e122e.cloudfunctions.net/handle_friend_request";

class ConnectPlusService {
  
  static async getFriendRequests() {
    try {
      const auth =
        getAuth();
  
      await auth.authStateReady();
  
      const currentUser =
        auth.currentUser;
  
      if (!currentUser) {
        console.warn(
          "❌ Пользователь не авторизован → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return [];
      }
  
      const token =
        await currentUser.getIdToken();
  
      if (!token) {
        throw new Error(
          "❌ Не удалось получить токен"
        );
      }
  
      const response =
        await fetch(
          GET_REQUESTS_URL,
          {
            method: "GET",
  
            headers: {
              Authorization:
                `Bearer ${token}`,
  
              "Content-Type":
                "application/json",
            }
          }
        );
  
      if (
        response.status === 401
      ) {
        console.warn(
          "❌ Сессия недействительна → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return [];
      }
  
      if (!response.ok) {
        const errorText =
          await response.text();
  
        throw new Error(
          `⚠️ Ошибка запроса: ${response.status} — ${errorText}`
        );
      }
  
      const data =
        await response.json();
  
      console.log(
        "📥 Получены запросы в друзья:",
        data
      );
  
      return data.map(
        item =>
          new FriendRequest(item)
      );
  
    } catch (error) {
      console.error(
        "❌ Не удалось загрузить запросы в друзья:"
      );
  
      console.error(
        "➡️",
        error.message
      );
  
      return [];
    }
  }

  static async getFriends() {
    try {
      const auth =
        getAuth();
  
      await auth.authStateReady();
  
      const currentUser =
        auth.currentUser;
  
      if (!currentUser) {
        console.warn(
          "❌ Пользователь не авторизован → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return [];
      }
  
      const token =
        await currentUser.getIdToken();
  
      if (!token) {
        throw new Error(
          "❌ Не удалось получить токен"
        );
      }
  
      const response =
        await fetch(
          GET_FRIENDS_URL,
          {
            method: "GET",
  
            headers: {
              Authorization:
                `Bearer ${token}`,
  
              "Content-Type":
                "application/json",
            }
          }
        );
  
      if (
        response.status === 401
      ) {
        console.warn(
          "❌ Сессия недействительна → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return [];
      }
  
      if (!response.ok) {
        const errorText =
          await response.text();
  
        throw new Error(
          `⚠️ Ошибка запроса: ${response.status} — ${errorText}`
        );
      }
  
      const data =
        await response.json();
  
      console.log(
        "👥 Получены друзья:",
        data
      );
  
      return data.map(
        item =>
          new FriendRequest(item)
      );
  
    } catch (error) {
      console.error(
        "❌ Не удалось загрузить друзей:"
      );
  
      console.error(
        "➡️",
        error.message
      );
  
      return [];
    }
  }

  static async sendFriendRequest(targetUserId, deleteRequest = false) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен");

      const response = await fetch(SEND_FRIEND_REQUEST, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          requested_id: targetUserId,
          delete: deleteRequest // 🔁 новый параметр
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`⚠️ Ошибка запроса: ${response.status} — ${errorText}`);
      }

      console.log(deleteRequest ? "🗑️ Запрос удалён" : "✅ Запрос отправлен");
      return true;
    } catch (error) {
      console.error("❌ Ошибка при отправке/удалении запроса:");
      console.error("➡️", error.message);
      return false;
    }
  }

static async handleFriendRequestAction(requesterId, action) {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) throw new Error("❌ Пользователь не авторизован");

    const token = await currentUser.getIdToken(true);
    if (!token) throw new Error("❌ Не удалось получить токен");

    const response = await fetch("https://europe-west3-hyper-e122e.cloudfunctions.net/handle_friend_request", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        requester_id: requesterId,
        action: action,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`⚠️ Ошибка запроса: ${response.status} — ${errorText}`);
    }

    console.log(`✅ Запрос ${action} успешно обработан`);
    return true;
  } catch (error) {
    console.error(`❌ Не удалось обработать запрос (${action}):`);
    console.error("➡️", error.message);
    return false;
  }
}

static async removeFriend(userIdToRemove) {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) throw new Error("❌ Пользователь не авторизован");

    const token = await currentUser.getIdToken(true);
    if (!token) throw new Error("❌ Не удалось получить токен");

    const response = await fetch("https://europe-west3-hyper-e122e.cloudfunctions.net/remove_friend", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id_2: userIdToRemove
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`⚠️ Ошибка при удалении друга: ${response.status} — ${errorText}`);
    }

    console.log("🗑️ Друг успешно удалён");
    return true;
  } catch (error) {
    console.error("❌ Не удалось удалить друга:");
    console.error("➡️", error.message);
    return false;
  }
}

static async handleFriendRequestAction(requesterId, action) {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) throw new Error("❌ Пользователь не авторизован");

    const token = await currentUser.getIdToken(true);
    if (!token) throw new Error("❌ Не удалось получить токен");

    const response = await axios.post(
      HANDLE_FRIEND_REQUEST,
      {
        requester_id: requesterId,
        action: action, // "accept" | "decline"
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log(`✅ Запрос ${action} успешно обработан`, response.data);
    return true;

  } catch (error) {
    if (error.response) {
      console.error("❌ Ошибка сервера:", error.response.status, error.response.data);
    } else {
      console.error("❌ Ошибка сети:", error.message);
    }
    return false;
  }
}

}

export default ConnectPlusService;